import { useEffect } from 'react';

const useBeforeUnload = ({ when }) => {
  useEffect(() => {
    const onBeforeUnload = e => {
      if (when) {
        e.preventDefault();
        // Newer browsers don't allow setting a custom message.
        // See https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event#compatibility_notes.
        return (e.returnValue = '');
      }
    };

    window.addEventListener('beforeunload', onBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
    };
  }, [when]);
};

export default useBeforeUnload;
